import { headerStyles as styles } from "@insite/content-library/Widgets/VmiReporting/VmiReportingHeader";
import { css } from "styled-components";

styles.titleText = {
    css: css`
        display: none;
    `,
};
